"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TeamType = void 0;
var TeamType;
(function (TeamType) {
    TeamType["AWS"] = "aws";
    TeamType["AZURE"] = "azure";
    TeamType["GCP"] = "gcp";
    TeamType["MULTICLOUD"] = "multicloud";
})(TeamType || (exports.TeamType = TeamType = {}));
//# sourceMappingURL=TeamType.js.map